"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Frame = void 0;
var estiloFrame = require('./Frame.module.scss');
var react_1 = __importStar(require("react"));
var BarraLateral_1 = require("../BarraLateral/BarraLateral");
var Cabecalho_1 = require("../Cabecalho/Cabecalho");
var Rodape_1 = require("../Rodape/Rodape");
var Divider_1 = require("../Divider/Divider");
var Frame = function (_a) {
    var _b = _a.semMargem, possuiIframe = _b === void 0 ? false : _b, dadosBarraLateral = _a.dadosBarraLateral, dadosCabecalho = _a.dadosCabecalho, children = _a.children, dadosRodape = _a.dadosRodape;
    var conteudoRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (conteudoRef.current) {
            conteudoRef.current.scrollTop = 0;
        }
    }, [children]);
    var _c = react_1.default.useState(false), barraLateralExpandida = _c[0], setBarraLateralExpandida = _c[1];
    var handleBarraExtendida = function () {
        setBarraLateralExpandida(!barraLateralExpandida);
    };
    // const [ferramentaAtiva, setFerramentaAtiva] = React.useState<number | undefined>(dadosBarraLateral?.itemAtivo);
    var handleFerramentaClicada = function (index) {
        if (dadosBarraLateral === null || dadosBarraLateral === void 0 ? void 0 : dadosBarraLateral.selecionarFerramenta) {
            dadosBarraLateral.selecionarFerramenta(index);
        }
    };
    // useEffect(() => {
    //     setFerramentaAtiva(dadosBarraLateral?.itemAtivo);
    // }, [dadosBarraLateral?.itemAtivo]);
    return (react_1.default.createElement("div", { ref: conteudoRef, className: "".concat(estiloFrame.frame, " ").concat(barraLateralExpandida ? estiloFrame.expandido : '') },
        react_1.default.createElement("div", { className: "".concat(estiloFrame.cabecalho) },
            react_1.default.createElement(Cabecalho_1.Cabecalho, __assign({}, dadosCabecalho))),
        react_1.default.createElement("div", { className: "".concat(estiloFrame.barraLateral) },
            react_1.default.createElement(BarraLateral_1.BarraLateral, __assign({}, dadosBarraLateral, { barraExtendida: barraLateralExpandida, expandirBarraLateral: handleBarraExtendida, selecionarFerramenta: handleFerramentaClicada }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: estiloFrame.mainFooter },
                react_1.default.createElement("div", { className: "".concat(estiloFrame.conteudo, " ").concat(possuiIframe ? estiloFrame.conteudoIframe : "") }, children),
                react_1.default.createElement("div", { className: estiloFrame.rodape },
                    react_1.default.createElement(Divider_1.Divider, { style: { boxShadow: '0px -2px 5px 0px rgba(0, 0, 0, 0.2)', marginBottom: '.5rem' } }),
                    react_1.default.createElement(Rodape_1.Rodape, __assign({}, dadosRodape)))))));
};
exports.Frame = Frame;
